/*
  Toasts are lightweight notifications designed to mimic the push notifications that have been popularized by mobile and desktop operating systems.
  They’re built with flexbox, so they’re easy to align and position.

 * @example
 *
 *  window.ToastNotification({
 *    // The message to display
 *    message: 'Hi!'
 *
 *    // The horizontal/vertical alignment
 *    horizontal: 'center' | 'left'| 'right',
 *    vertical: 'bottom' | 'top',
 *
 *    // The number of milliseconds to wait before automatically calling the onClose function
 *    autoHideDuration: null,
 *
 *    anchorElement: { href='#', name='details...' }
 *  })
*/

import React, { useState, useEffect } from 'react';
import { createRoot } from "react-dom/client";
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';

const ToastNotificationContent = ({keySnackbar, message, vertical = 'bottom', horizontal = 'left', autoHideDuration = null, anchorElement = null}) => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setOpen(true);
  }, [keySnackbar]);

  return (
    <Snackbar
      key={keySnackbar}
      open={open}
      onClose={handleClose}
      anchorOrigin={{ vertical, horizontal }}
      autohideduration={autoHideDuration}
      message={
        <>
          <div style={{maxWidth: 300}}>{message}</div>
          {anchorElement &&
            <a
              href={anchorElement.href}
              target='_blank'
              className='btn btn-link p-0'
              {...(anchorElement.onClick ? {onClick: anchorElement.onClick} : {})}
            >
              {anchorElement.name}
            </a>
          }
        </>
      }
      ContentProps={{
        sx: {
          color: '#000000de',
          bgcolor: '#fbfbfbe3',
          mx: 0.5,
          fontSize: 15
        }
      }}
      action={
        <React.Fragment>
          <IconButton
            aria-label='close'
            color='inherit'
            onClick={handleClose}
          >
            <i className='glyphicon glyphicon-remove' style={{opacity: 0.3}}/>
          </IconButton>
        </React.Fragment>
      }
    />
  );
};

const CONTAINER_ID = 'MuiSnackbar-root';
let root = null;
export default function ToastNotification(props) {
  if (!document.getElementById(CONTAINER_ID)) {
    var div = document.createElement('div');
    div.id = CONTAINER_ID;
    document.body.appendChild(div);
  }
  //if (!root){
    root = createRoot(document.getElementById(CONTAINER_ID));
  //}
  root.render(<ToastNotificationContent keySnackbar={new Date().getTime()} {...props}/>);
};
